
(function(){
  function initCustomizer(root){
    if(!root) return;

    var state = {
      product: 'shirt',
      size: 'S',
      name: 'DARBI',
      number: '10',
      zone: 'Face avant uniquement',
      zoneKey: 'front',
      shirtPrice: '22,50 €',
      shirtFile: 'Aucun fichier',
      phone: 'iPhone 11',
      caseFile: 'Aucun fichier',
      caseNote: 'Aucune note',
      shirtZoom: 100,
      caseZoom: 100,
      textColor: '#D4AF37',
      numberStyle: 'Classique',
      shirtFileObject: null,
      caseFileObject: null
    };

    function all(sel){ return root.querySelectorAll(sel); }
    function one(sel){ return root.querySelector(sel); }
    function setText(sel,val){ var el=one(sel); if(el) el.textContent=val; }

    function toggleBackInfo(){
      var showBack = state.zoneKey === 'back' || state.zoneKey === 'both';
      all('[data-summary-back-info]').forEach(function(el){
        el.style.display = showBack ? '' : 'none';
      });
    }

    function formatEuro(value){
      var number = parseFloat(value || 0);
      return number.toFixed(2).replace('.', ',') + ' €';
    }

    function setMessage(msg, ok){
      var el = one('[data-cart-message]');
      if(!el) return;
      el.textContent = msg || '';
      el.classList.toggle('is-ok', !!ok);
      el.classList.toggle('is-error', !!msg && !ok);
    }

    all('[data-customizer-tab]').forEach(function(btn){
      btn.addEventListener('click', function(){
        var target = btn.getAttribute('data-customizer-tab');
        state.product = target === 'case' ? 'case' : 'shirt';

        all('[data-customizer-tab]').forEach(function(b){ b.classList.remove('is-active'); });
        btn.classList.add('is-active');

        all('[data-preview-panel]').forEach(function(panel){
          panel.classList.toggle('is-active', panel.getAttribute('data-preview-panel') === target);
        });

        all('[data-form-panel]').forEach(function(panel){
          panel.classList.toggle('is-active', panel.getAttribute('data-form-panel') === target);
        });

        all('[data-summary-panel]').forEach(function(panel){
          panel.classList.toggle('is-active', panel.getAttribute('data-summary-panel') === target);
        });

        setMessage('', false);
        updateWhatsapp();
      });
    });

    all('[data-shirt-view]').forEach(function(btn){
      btn.addEventListener('click', function(){
        var target = btn.getAttribute('data-shirt-view');
        all('[data-shirt-view]').forEach(function(b){ b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        all('[data-shirt-preview]').forEach(function(v){
          v.classList.toggle('is-active', v.getAttribute('data-shirt-preview') === target);
        });
      });
    });

    var nameInput = one('[data-name-input]');
    var numberInput = one('[data-number-input]');
    var colorInput = one('[data-text-color]');
    var phoneInput = one('[data-phone-model]');
    var caseNoteInput = one('[data-case-note]');
    var numberStyleInput = one('[data-number-style]');

    if(nameInput){
      nameInput.addEventListener('input', function(){
        state.name = (nameInput.value || 'VOTRE NOM').toUpperCase();
        setText('[data-shirt-name]', state.name);
        setText('[data-shirt-name-mini]', state.name);
        setText('[data-summary-name]', state.name);
        updateWhatsapp();
      });
    }

    if(numberInput){
      numberInput.addEventListener('input', function(){
        state.number = numberInput.value || '10';
        setText('[data-shirt-number]', state.number);
        setText('[data-shirt-number-mini]', state.number);
        setText('[data-summary-number]', state.number);
        updateWhatsapp();
      });
    }

    if(colorInput){
      colorInput.addEventListener('input', function(){
        var color = colorInput.value.toUpperCase();
        state.textColor = color;
        setText('[data-color-value]', color);
        var n = one('[data-shirt-name]');
        var num = one('[data-shirt-number]');
        if(n) n.style.color = color;
        if(num) num.style.color = color;
      });
    }

    all('[data-size]').forEach(function(btn){
      btn.addEventListener('click', function(){
        all('[data-size]').forEach(function(b){ b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        state.size = btn.getAttribute('data-size');
        var select = one('[data-shirt-size]');
        if(select) select.value = state.size;
        setText('[data-summary-size]', state.size);
        updateWhatsapp();
      });
    });

    all('[data-zone]').forEach(function(btn){
      btn.addEventListener('click', function(){
        all('[data-zone]').forEach(function(b){ b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        state.zone = btn.getAttribute('data-zone');
        state.zoneKey = btn.getAttribute('data-zone-key') || 'front';
        var variantPrice = root.getAttribute('data-shirt-variant-' + state.zoneKey + '-price');
        state.shirtPrice = variantPrice ? (variantPrice + ' €') : formatEuro(btn.getAttribute('data-price'));
        var select = one('[data-shirt-zone]');
        if(select) select.value = state.zone;
        setText('[data-summary-zone]', state.zone);
        setText('[data-summary-shirt-price]', state.shirtPrice);
        toggleBackInfo();
        updateWhatsapp();
      });
    });



    if(numberStyleInput){
      numberStyleInput.addEventListener('change', function(){
        state.numberStyle = numberStyleInput.value || 'Classique';
        updateWhatsapp();
      });
    }

    if(phoneInput){
      phoneInput.addEventListener('change', function(){
        state.phone = phoneInput.value;
        setText('[data-summary-phone]', state.phone);
        updateWhatsapp();
      });
    }

    if(caseNoteInput){
      caseNoteInput.addEventListener('input', function(){
        state.caseNote = caseNoteInput.value || 'Aucune note';
        setText('[data-summary-case-note]', state.caseNote);
        updateWhatsapp();
      });
    }

    function previewFile(input, target, summarySelector, key, objectKey){
      if(!input || !target) return;
      input.addEventListener('change', function(){
        var file = input.files && input.files[0];
        if(!file) return;

        state[key] = file.name;
        state[objectKey] = file;
        setText(summarySelector, file.name);
        updateWhatsapp();

        if(file.type && file.type.indexOf('image/') === 0){
          var reader = new FileReader();
          reader.onload = function(e){
            target.innerHTML = '';
            var img = document.createElement('img');
            img.src = e.target.result;
            img.alt = 'Aperçu design';
            target.appendChild(img);
            if(objectKey === 'caseFileObject'){
              applyZoom('case');
            } else {
              applyZoom('shirt');
            }
          };
          reader.readAsDataURL(file);
        } else {
          target.innerHTML = '<span>Fichier reçu<br>' + file.name + '</span>';
        }
      });
    }

    previewFile(one('[data-file-input="shirt"]'), one('[data-shirt-design]'), '[data-summary-shirt-file]', 'shirtFile', 'shirtFileObject');
    previewFile(one('[data-file-input="case"]'), one('[data-case-design]'), '[data-summary-case-file]', 'caseFile', 'caseFileObject');


    function applyZoom(type){
      var zoom = type === 'case' ? state.caseZoom : state.shirtZoom;
      var target = type === 'case' ? one('[data-case-design] img') : one('[data-shirt-design] img');
      var label = one('[data-zoom-value="' + type + '"]');
      if(label) label.textContent = zoom + '%';
      if(target){
        target.style.transform = 'scale(' + (zoom / 100) + ')';
      }
    }

    function changeZoom(type, delta){
      if(type === 'case'){
        state.caseZoom = Math.max(50, Math.min(200, state.caseZoom + delta));
        applyZoom('case');
      } else {
        state.shirtZoom = Math.max(50, Math.min(200, state.shirtZoom + delta));
        applyZoom('shirt');
      }
    }

    all('[data-zoom-minus]').forEach(function(btn){
      btn.addEventListener('click', function(){
        changeZoom(btn.getAttribute('data-zoom-minus'), -10);
      });
    });

    all('[data-zoom-plus]').forEach(function(btn){
      btn.addEventListener('click', function(){
        changeZoom(btn.getAttribute('data-zoom-plus'), 10);
      });
    });

    function updateWhatsapp(){
      var msg;
      if(state.product === 'case'){
        msg = 'Bonjour, je souhaite personnaliser une coque.%0A' +
          'Modèle : ' + state.phone + '%0A' +
          'Fichier : ' + state.caseFile + '%0A' +
          'Note : ' + state.caseNote;
      } else {
        msg = 'Bonjour, je souhaite personnaliser un maillot.%0A' +
          'Taille : ' + state.size + '%0A' +
          'Impression : ' + state.zone + '%0A';
        if(state.zoneKey === 'back' || state.zoneKey === 'both'){
          msg += 'Nom au dos : ' + state.name + '%0A' +
            'Numéro au dos : ' + state.number + '%0A' +
            'Style numéro : ' + state.numberStyle + '%0A' +
            'Couleur texte : ' + state.textColor + '%0A';
        }
        msg += 'Prix : ' + state.shirtPrice + '%0A' +
          'Fichier : ' + state.shirtFile;
      }

      var whatsapp = one('[data-whatsapp-link]');
      if(whatsapp){
        var base = whatsapp.getAttribute('href').split('?')[0];
        whatsapp.setAttribute('href', base + '?text=' + msg);
      }
    }

    function getVariantId(){
      if(state.product === 'case'){
        return root.getAttribute('data-case-variant');
      }

      var key = state.zoneKey || 'front';
      var variantId = root.getAttribute('data-shirt-variant-' + key);
      return variantId || root.getAttribute('data-shirt-variant');
    }

    function buildFormData(){
      var variantId = getVariantId();
      var fd = new FormData();

      fd.append('id', variantId);
      fd.append('quantity', '1');

      if(state.product === 'case'){
        fd.append('properties[Type de produit]', 'Coque personnalisée');
        fd.append('properties[Modèle téléphone]', state.phone);
        fd.append('properties[Fichier design]', state.caseFile);
        fd.append('properties[Note client]', state.caseNote);
        fd.append('properties[Résumé personnalisation]', 'Coque / ' + state.phone + ' / ' + state.caseFile);
        if(state.caseFileObject){
          fd.append('properties[Fichier uploadé]', state.caseFileObject);
        }
      } else {
        fd.append('properties[Type de produit]', 'Maillot personnalisé');
        fd.append('properties[Taille]', state.size);
        fd.append('properties[Impression]', state.zone);
        if(state.zoneKey === 'back' || state.zoneKey === 'both'){
          fd.append('properties[Nom au dos]', state.name);
          fd.append('properties[Numéro au dos]', state.number);
          fd.append('properties[Style numéro]', state.numberStyle);
          fd.append('properties[Couleur texte]', state.textColor);
          fd.append('properties[Résumé personnalisation]', 'Maillot / ' + state.size + ' / ' + state.zone + ' / ' + state.name + ' ' + state.number);
        } else {
          fd.append('properties[Résumé personnalisation]', 'Maillot / ' + state.size + ' / ' + state.zone);
        }
        fd.append('properties[Prix option]', state.shirtPrice);
        fd.append('properties[Fichier design]', state.shirtFile);
        if(state.shirtFileObject){
          fd.append('properties[Fichier uploadé]', state.shirtFileObject);
        }
      }

      fd.append('properties[Validation]', 'Design à vérifier avant fabrication');
      return fd;
    }

    function addToCart(redirect){
      var variantId = getVariantId();
      if(!variantId){
        setMessage('Configuration nécessaire : sélectionne les produits Shopify dans l’éditeur du thème.', false);
        return;
      }

      setMessage('Ajout au panier en cours...', true);

      fetch('/cart/add.js', {
        method: 'POST',
        body: buildFormData()
      })
      .then(function(res){
        if(!res.ok) throw new Error('Erreur panier');
        return res.json();
      })
      .then(function(){
        setMessage('Produit personnalisé ajouté au panier.', true);
        if(redirect){
          window.location.href = root.getAttribute('data-cart-url') || '/cart';
        }
      })
      .catch(function(){
        setMessage('Impossible d’ajouter au panier. Vérifie que le produit est bien configuré dans le thème.', false);
      });
    }

    var addBtn = one('[data-add-cart]');
    var buyBtn = one('[data-buy-now]');

    if(addBtn){
      addBtn.addEventListener('click', function(){
        addToCart(false);
      });
    }

    if(buyBtn){
      buyBtn.addEventListener('click', function(){
        addToCart(true);
      });
    }

    var initialVariantPrice = root.getAttribute('data-shirt-variant-front-price');
    if(initialVariantPrice){
      state.shirtPrice = initialVariantPrice + ' €';
      setText('[data-summary-shirt-price]', state.shirtPrice);
    }
    toggleBackInfo();
    updateWhatsapp();
  }

  document.addEventListener('DOMContentLoaded', function(){
    document.querySelectorAll('[data-mfc-customizer]').forEach(initCustomizer);
  });
})();
